import React from "react";

/** Loading placeholder for the verdict screen. It reuses the real layout
 *  classes (`vb-verdict` / `vb-sigpanel` / `vb-tabs` / `vb-qcard`) and only
 *  swaps the data for `vb-skel` bones, so the skeleton occupies the same
 *  footprint and reflows the same way on desktop and mobile as the filled
 *  verdict — the page reads as itself before the data lands (mirrors the
 *  buyer-wizard PickerSkeleton approach). */
export function VerdictSkeleton() {
  return (
    <div className="vb-verdict-page" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading verdict…</span>

      {/* Breadcrumb / step row ghost */}
      <span
        className="vb-skel vb-skel-line"
        style={{ width: 130, height: 12 }}
        aria-hidden="true"
      />

      {/* Hero card: headline column + signal-exposure panel */}
      <section className="vb-verdict" aria-hidden="true">
        <div className="vb-verdict__body">
          <div className="vb-verdict__main">
            <span className="vb-skel vb-skel-line vb-skel-line--sm" style={{ width: 92 }} />
            <span
              className="vb-skel vb-skel-line vb-skel-line--title"
              style={{ width: "82%", marginTop: 12 }}
            />
            <span className="vb-skel vb-skel-line" style={{ width: "96%", marginTop: 14 }} />
            <span className="vb-skel vb-skel-line" style={{ width: "58%", marginTop: 6 }} />
          </div>

          <div className="vb-sigpanel">
            <div className="vb-sigpanel__hd">
              <span className="vb-skel vb-skel-line vb-skel-line--sm" style={{ width: 150 }} />
            </div>
            <div className="vb-sig-meter">
              {Array.from({ length: 19 }).map((_, i) => (
                <span key={i} className="vb-sig-meter__seg" />
              ))}
            </div>
            {Array.from({ length: 3 }).map((_, r) => (
              <div className="vb-sig-row" key={r}>
                <span className="vb-skel vb-skel-line vb-skel-line--sm" style={{ width: 58 }} />
                <div className="vb-sig-row__pills">
                  {[68, 52, 80].map((w, i) => (
                    <span
                      key={i}
                      className="vb-skel"
                      style={{ width: w, height: 18, borderRadius: 4 }}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="vb-scoreguide">
          <span className="vb-skel vb-skel-line vb-skel-line--sm" style={{ width: "70%" }} />
        </div>
      </section>

      {/* Big-5 tab bar */}
      <div className="vb-tabs vb-tabs--segmented" aria-hidden="true">
        {Array.from({ length: 5 }).map((_, i) => (
          <span
            key={i}
            className="vb-skel"
            style={{ width: 104, height: 30, borderRadius: 8, flexShrink: 0 }}
          />
        ))}
      </div>

      {/* Question cards */}
      <div className="vb-qcards" aria-hidden="true">
        {Array.from({ length: 2 }).map((_, i) => (
          <article className="vb-qcard vb-qcard--skeleton" key={i}>
            <div className="vb-qcard__hd">
              <span className="vb-skel vb-skel-line vb-skel-line--title" style={{ width: "56%" }} />
              <span className="vb-skel" style={{ width: 60, height: 20, borderRadius: 999 }} />
            </div>
            <span className="vb-skel vb-skel-line" style={{ width: "94%" }} />
            <span className="vb-skel vb-skel-line" style={{ width: "72%" }} />
            <div className="vb-qcard__signals">
              {[66, 84, 58].map((w, j) => (
                <span
                  key={j}
                  className="vb-skel"
                  style={{ width: w, height: 18, borderRadius: 4 }}
                />
              ))}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

export default VerdictSkeleton;
